// ============================================
// Factory
// ============================================

import { $$ } from 'utils/select';

// Takes a class and a selector and initializes
// a new class instance for each occurrence of the selector.
// Returns an array with all instances.

export default (fn, el, hide = false) => {
  const els = $$(el);
  const instances = [];

  if (!hide && els.length > 0) {
    els.forEach((el) => {
      instances.push(fn(el));
    });
  }

  return instances;
};
